module.exports = __webpack_public_path__ + "img/header-kontakt-icon-white.22cb6a9d.svg";